
export class CSRF {
    static getCsrfTokenValue() : string {
        let csrfTokenValue = window["getCsrfTokenValue"];
        if (!csrfTokenValue) {
            return "TEMP_VAL"
        } else {
            return csrfTokenValue();
        }
    }

    static getCsrfTokenName() :string {
        let csrfTokenName = window["getCsrfTokenName"];
        if (!csrfTokenName) {
            return "AUTH_TOKEN"
        } else {
            return csrfTokenName();
        }
    }


    static getCsrfToken(): string {
        let csrfToken = window["getCsrfToken"];
        if (!csrfToken) {
            return "AUTH_TOKEN=TEMP_VAL"
        } else {
            return csrfToken();
        }
    }
}
